import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeColors } from '../../constants/themes';
import { Circle, StepDescription } from '../common/FlexStyle';

const Wrapper = styled('div')`
  width: 20%;
`;

const Number = styled('div')`
  position: relative;
  font-size: 50px;
  top: 175px;
  height: 60px;
  color: ${({ isDisabledByStep }) =>
    isDisabledByStep ? themeColors.dirtyLightBlue : themeColors.darkBlue};
  font-family: Heebo-Thin;
  font-size: 85px;
  font-weight: 100;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.21;
  letter-spacing: normal;
  text-align: left;
  color: #233b69;
`;

const DiscoverySectionInfo = props => {
  const { qNumber, content, isDisabledByStep } = props;
  return (
    <Wrapper>
      <Circle isDisabledByStep={isDisabledByStep}>
        <Number isDisabledByStep={isDisabledByStep}>{qNumber}</Number>
      </Circle>
      <StepDescription isDisabledByStep={isDisabledByStep}>{content}</StepDescription>
    </Wrapper>
  );
};

DiscoverySectionInfo.propTypes = {
  qNumber: PropTypes.number,
  content: PropTypes.string,
  isDisabledByStep: PropTypes.bool,
};

export default DiscoverySectionInfo;
